
import { useState } from "react";
import { useParams } from "react-router-dom";
import { Button, Grid, MenuItem, TextField } from "@mui/material"
import { useQueryClient } from "@tanstack/react-query";
import { useEncubadoraQuery, useGranjasQuery } from "../../../../hooks";
import { startSavingLotes } from "../../../../services";
import { InputSeparadorDecimal } from "../../inputs/InputSeparadorDecimal";

import Swal from "sweetalert2";





export const FormCreateUpdateLote = ({ initialState }) => {


    const { id } = useParams();
    const { granjasListQuery } = useGranjasQuery()
    const { encubadoraListQuery } = useEncubadoraQuery();
    const queryClient = useQueryClient();



    const [formLote, setFormLote] = useState(initialState)
    const { granja, encubadora, cantidadTotal, factura, machos, hembras } = formLote;
    const handleChangeInput = ({ target }) => {
        setFormLote({
            ...formLote,
            [target.name]: target.value
        });
    }


    
    const crearActInformacion = async(e) => {
        e.preventDefault();
        if([granja, encubadora, cantidadTotal, factura, machos, hembras].includes('') ){
            return Swal.fire('Error', 'Formulario incorrecto por favor llene todos los campos', 'error');
        }
        if( Number(cantidadTotal) !== (Number(machos) + Number(hembras)) ){
            return Swal.fire('Error', 'Las cantidades no coinciden, verifique por favor', 'error');
        }

        const result = await Swal.fire({
            title: `${(id) ? 'Actualizar' : 'Crear'} Lote`,
            text: `¿Esta seguro de ${(id) ? 'Actualizar' : 'Crear'} Lote?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: `Si ${(id) ? 'Actualizar' : 'Crear'}`,
            cancelButtonText: 'Cancelar'
        });

        if (!result.isConfirmed) return;

        const resp = await startSavingLotes({...formLote, id});
        if(resp){
            if(!id) { 
                setFormLote(initialState); 
            }
            queryClient.invalidateQueries({queryKey: ['lotes-list']});
        }
    }



    return (
        <form onSubmit={ crearActInformacion } >
            <Grid container spacing={ 2 }>

                <Grid item xs={12} sm={6}>
                    <TextField required
                        label='Factura'
                        type='text'
                        placeholder='Factura'
                        fullWidth
                        name='factura'
                        value={ factura }
                        onChange={ handleChangeInput }
                    />
                </Grid>

                {(granjasListQuery?.data?.length > 0) &&
                <Grid item xs={12} sm={6}>
                    <TextField
                        required
                        select
                        label="Seleccione Granja"
                        fullWidth
                        name="granja"
                        value={granja || ''}
                        onChange={handleChangeInput}
                    >
                        <MenuItem value="">Seleccione Granja</MenuItem>
                        {Array.isArray(granjasListQuery?.data) && granjasListQuery.data.length > 0 ? (
                            granjasListQuery.data.map((g) => (
                                <MenuItem key={g.id} value={g.id}>
                                    {g.nombre}
                                </MenuItem>
                            ))
                        ) : (
                            <MenuItem disabled>No hay granjas disponibles</MenuItem>
                        )}
                    </TextField>
                </Grid>
                }

                {(encubadoraListQuery?.data?.length > 0) &&
                <Grid item xs={12} sm={6}>
                    <TextField required
                        select
                        label="Selecione Incubadora"
                        fullWidth
                        value={encubadora || ''}
                        name='encubadora'
                        onChange={ handleChangeInput }
                    >
                        <MenuItem value=''>Selecione Incubadora</MenuItem>
                        {Array.isArray(encubadoraListQuery?.data) && encubadoraListQuery?.data.length > 0 ? (
                            encubadoraListQuery?.data.map((g) => (
                                <MenuItem key={g.id} value={g.id}>
                                    {g.nombre}
                                </MenuItem>
                            ))
                        ) : (
                            <MenuItem disabled>No hay granjas disponibles</MenuItem>
                        )}
                    </TextField>
                </Grid>
                }

                <Grid item xs={12} sm={6}>
                    <InputSeparadorDecimal required
                        label='Cantidad Total'
                        placeholder='Cantidad Total'
                        fullWidth
                        name='cantidadTotal'
                        value={ cantidadTotal }
                        onChange={ handleChangeInput }
                    />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <InputSeparadorDecimal required
                        label='Cantidad Machos'
                        placeholder='Cantidad Machos'
                        fullWidth
                        name='machos'
                        value={ machos }
                        onChange={ handleChangeInput }
                    />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <InputSeparadorDecimal required
                        label='Cantidad Hembras'
                        placeholder='Cantidad Hembras'
                        fullWidth
                        name='hembras'
                        value={ hembras }
                        onChange={ handleChangeInput }
                    />
                </Grid>

            </Grid>

            <Grid container sx={{ my:4 }} direccion='column' justifyContent='center'>
                <Grid item xs={ 12 } sm={ 8 } >
                    <Button variant='contained' fullWidth type='submit'>
                        {`${id ? 'Actualizar' : 'Crear'} Lote`}
                    </Button>
                </Grid>
            </Grid>
        </form>

    )
}
